import React, { createContext, useContext, useEffect, useState } from "react";
import { translate } from "@/lib/i18n";

const KEY = "borehub_checklist_lang";
const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (v === "es" || v === "en") setLangState(v);
  }, []);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem(KEY, l);
  };

  const t = (key) => translate(lang, key);

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
